import { useId } from 'react';
import styles from './Input.module.css';

// Labeled text input with optional error message.
export default function Input({
  label,
  error,
  className = '',
  ...rest
}) {
  const id = useId();
  return (
    <div className={`${styles.field} ${className}`}>
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      )}
      <input
        id={id}
        className={`${styles.input} ${error ? styles.inputError : ''}`}
        {...rest}
      />
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
}
